
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"186","height":"82","viewBox":"0 0 1860 820"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 808c-17-17-17-619 0-636 8-8 67-12 198-12h185l260-80C798 36 922 0 931 0s134 36 277 80l259 80h185c130 0 188 4 196 12 17 17 17 619 0 636S29 825 12 808z","fill":"#00a8e9"}})])
          )
        }
      }
    